"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookie = exports.getCookie = void 0;
exports.getSessionId = getSessionId;
exports.getRedirectedFrom = getRedirectedFrom;
exports.isDebugCookieSet = isDebugCookieSet;
const cookie_1 = __importDefault(require("cookie"));
const getCookie = (name) => {
    if (typeof document !== 'undefined' && navigator && navigator.cookieEnabled) {
        const cookies = cookie_1.default.parse(document.cookie);
        if (!name) {
            return undefined;
        }
        if (cookies[name]) {
            return cookies[name];
        }
    }
    return undefined;
};
exports.getCookie = getCookie;
const setCookie = (cname, cvalue, options = {}) => {
    if (typeof document !== 'undefined' && navigator && navigator.cookieEnabled) {
        const ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60;
        const defaultOptions = {
            maxAge: ONE_YEAR_IN_SECONDS,
            path: '/',
            domain: undefined,
        };
        const mergedOptions = Object.assign(Object.assign({}, defaultOptions), options);
        document.cookie = cookie_1.default.serialize(cname, cvalue, mergedOptions);
        if (window.location.hostname === 'localhost') {
            const localMergedOptions = Object.assign({}, mergedOptions);
            delete localMergedOptions.domain;
            document.cookie = cookie_1.default.serialize(cname, cvalue, localMergedOptions);
        }
    }
};
exports.setCookie = setCookie;
function getSessionId() {
    return (0, exports.getCookie)('FCID');
}
function getRedirectedFrom() {
    return (0, exports.getCookie)('redirectedFrom');
}
function isDebugCookieSet() {
    return (0, exports.getCookie)('onesegmentdebug') === 'true';
}
//# sourceMappingURL=cookies.js.map